let clickButton = document.querySelectorAll('.js-toggle-button')
if (clickButton) {
    clickButton.forEach(button => {
        button.addEventListener('click', function () {
            const parent = document.getElementById(button.dataset.target)
            const hideInfo = parent.getElementsByClassName('js-hide-info')[0]
            const showInfo = parent.getElementsByClassName('js-show-info')[0]

            if (hideInfo.style.display === "none") {
                hideInfo.style.display = "block";
                showInfo.style.display = "none"
            } else {
                hideInfo.style.display = "none";
                showInfo.style.display = "block"
            }
        })
    })
}



